import { Badge, Button } from "@aws-amplify/ui-react";
import { IoIosArrowForward } from 'react-icons/io'
import { SiMicrosoftexcel } from 'react-icons/si'
import { FaCheckCircle, FaExternalLinkAlt } from 'react-icons/fa'
import { memo } from "react";
import { OrderInspectionLog } from "./types";
import { formatDateISOToTh, formatDateUnixToTh, formatNumberV2 } from "../utilities/Format";
import { AvgFwtByLot } from "../models";
import { VscWarning } from "react-icons/vsc";

const FGInspectMenu = ({ formLog, hideArrow = false, showAction = false, onStartRecord, loading = false, isShowLink = false, approved = false } : {
  formLog: OrderInspectionLog,
  hideArrow?: boolean
  showAction?: boolean
  onStartRecord?: () => void,
  loading?: boolean,
  isShowLink?: boolean
  approved?: boolean
}) => {
  const splitFormType = formLog.inspectionType.split('_')

  const clickToViewReport = (reportUrl: string) => {
    // note - direct to form path (inspection-forms/...)
    window.open(reportUrl, '_blank');
  }

  const avgFwtByLots = formLog.avgFwtByLots ? (JSON.parse(formLog.avgFwtByLots) as AvgFwtByLot[]) : []

  return (
    <div className={`${formLog.inspectionStatus === 'SUBMITTED' ? ' bg-green-50' : 'bg-white'} w-full shadow rounded-xl${formLog.canEdit ? '':' opacity-30'}`}>
      <div className="flex items-center justify-between gap-6 p-4 ">
        <div className="inline-flex">
          <div className="inline-flex flex-col items-start justify-start gap-2">
            <Badge variation={splitFormType[0] === 'PD' ? 'success' : 'warning'} size="small">{splitFormType[0]}</Badge>
            <h4 className="font-bold text-black ">{splitFormType[1]}</h4>
          </div>
        </div>
        <div className="flex gap-2">
          <div className="flex flex-col gap-3">
            <div className="flex flex-col items-end ">
              {formLog.id === '' && <p className="font-bold text-red-600 ">ยังไม่เริ่มนับ</p>}
              {formLog.inspectionStatus === 'TESTING' && <p className="font-bold text-amber-600 ">กำลังนับ</p>}
              {formLog.inspectionStatus === 'SUBMITTED' && <p className="flex items-center gap-2 font-bold text-green-600 ">
                <FaCheckCircle className="text-green-500 " size={20}/>ส่งงานแล้ว
              </p>}
              {formLog.inspectionStatus === 'APPROVED' && <p className="font-bold text-green-900 ">อนุมัติแล้ว</p>}
              {formLog.inspectionStatus === 'TESTING' && 
                <p className="text-sm italic text-right text-muted ">{formatDateISOToTh(formLog.createdAt)}</p>}
              {formLog.inspectionStatus === 'SUBMITTED' &&
                <p className="text-sm italic text-right text-muted ">{formatDateUnixToTh(formLog.submittedDatetime)}</p>}
              {formLog.inspectionStatus === 'APPROVED' &&
                <p className="text-sm italic text-right text-muted ">{formatDateUnixToTh(formLog.approvedDatetime)}</p>}
            </div>
            {showAction && 
              <div className="flex flex-col items-end gap-1">
                <Button
                  gap="0.3rem"
                  isLoading={loading}
                  loadingText="กำลังสร้าง Excel file"
                  variation="primary"
                  className=" amplify-button-inspec"
                  onClick={onStartRecord}>
                  <SiMicrosoftexcel />{formLog.id === '' ? 'กดเพื่อสร้าง Excel ไฟล์' : 'เริ่มบันทึกผ่าน Excel'}
                </Button>
                { formLog.id === '' && !loading && <div className="flex flex-row gap-1"><VscWarning color="#ffc107"/><small className='italic text-yellow-500'>กรุณาเลือก Work Center ที่ผลิตจริงก่อนเริ่มบันทึก</small></div> }
                { loading && <small className='italic text-yellow-500'>รอสร้าง FORM ประมาณ 5-10 วินาที</small> }
              </div>
            }
          </div>
          {!hideArrow && <IoIosArrowForward size={24} />}
        </div>
      </div>
      {avgFwtByLots.length > 0 && <div className="flex flex-wrap gap-1 px-4 pb-4">
        {avgFwtByLots.map((avgFwt) => 
          <Badge key={avgFwt.BATCH_LOT} variation={'warning'} size="small">{avgFwt.BATCH_LOT}={formatNumberV2(avgFwt.AVG_FWT)}</Badge>
        )}
      </div>
      }
      {isShowLink ? <button
        className="flex items-center justify-center w-full gap-1 pb-3 work-center-edit"
        onClick={() => clickToViewReport(formLog.formUrl)}>
          <FaExternalLinkAlt />กดดู Report
      </button> : null}
    </div>
  )
}

export default memo(FGInspectMenu)